import React from "react";
import { ITranslitingTooltipProps } from "./TranslitingTooltip.props";
import { Tooltip } from "antd";
import { useTranslitingTooltipControl } from "./useTranslitingTooltipControl";
import styles from "./TranslitingTooltip.module.scss";
import { useIntl } from "react-intl";

export default function TranslitingTooltip({
  ...props
}: ITranslitingTooltipProps) {
  const { formatMessage } = useIntl();
  const control = useTranslitingTooltipControl(props);

  return (
    <Tooltip
      open={control.open}
      title={
        <p className={styles.text}>
          {formatMessage({ id: "transliting_tooltip.text" })}
        </p>
      }
      placement='right'
      color={"#0a28ab"}
    >
      {props.children}
    </Tooltip>
  );
}
